import { render, staticRenderFns } from "./PreviewTemplateDefault.vue?vue&type=template&id=60468782&scoped=true&"
import script from "./PreviewTemplateDefault.vue?vue&type=script&lang=js&"
export * from "./PreviewTemplateDefault.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTemplateDefault.vue?vue&type=style&index=0&id=60468782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60468782",
  null
  
)

export default component.exports